// actions/otpActions.js
import createApi from "../utils/apiClient";
const api = createApi();

// channel: "email" | "sms"   purpose: "signup" | "password_reset"
export const sendOtp = (identifier, channel, purpose) => async () => {
  try {
    const { data } = await api.post("/otp/send", {
      identifier,
      channel,
      purpose,
    });
    return { success: true, message: data.message };
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || "Could not send OTP",
    };
  }
};

export const verifyOtp = (identifier, otp, purpose) => async () => {
  try {
    const { data } = await api.post("/otp/verify", {
      identifier,
      otp,
      purpose,
    });
    return { success: true, message: data.message };
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || "Invalid OTP",
    };
  }
};
